export default __webpack_public_path__ + "static/media/cover.20b0ac03.jpg";